import moment from 'moment';
import Firebase from '../../../lib/Firebase';
import Firestore from '../../../lib/Firestore';
import EventBus from '../../../main';

export default {
  fetchCriticalOrders (city) {
    const cityRef = Firebase.firestore().collection('cities').doc(city.id);
    const today = moment().startOf('day').valueOf();

    return Firebase.firestore().collection('orders')
      .where('city', '==', cityRef)
      .where('datetime', '<', today)
      .get()
      .then((docs) => {
        const items = Firestore.getCollectionData(docs);
        const orders = items.filter(order => (order.orderStatus !== 'DELIVERED' && order.orderStatus !== 'CANCELLED'));
        return orders;
      });
  },

  fetchTodayTomorrowOrders (city) {
    const cityRef = Firebase.firestore().collection('cities').doc(city.id);
    const today = moment().startOf('day').valueOf();
    const tomorrow = moment().add(1, 'day').startOf('day').valueOf();

    return Firebase.firestore().collection('orders')
      .where('city', '==', cityRef)
      .where('datetime', '>=', today)
      .onSnapshot((docs) => {
        const items = Firestore.getCollectionData(docs);
        const todays = items.filter(order =>
          moment(order.deliveryOptionDate).isAfter(moment(today)) && moment(order.deliveryOptionDate).isBefore(moment(tomorrow))
        );

        const tomorrows = items.filter(order =>
          moment(order.deliveryOptionDate).isAfter(moment(tomorrow)));

        EventBus.$emit('newTodayTomorrowOrdersAvailable', [todays, tomorrows]);
      });
  },

  changeDeliveryboy (order, boy) {
    const updatedBoy = {
      id: boy.docId,
      name: boy.name,
      contact: boy.contact
    };

    return Firebase.firestore().collection('orders').doc(order).update({ deliveryBoy: updatedBoy });
  }
};



// WEBPACK FOOTER //
// ./src/pages/cities/Orders/service.js